import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stationApi from "@api/station";
import {
  Button,
  Table,
  Form,
  Input,
  Row,
  Col,
  Modal,
  message,
  Cascader,
  InputNumber,
  Select,
} from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import moment from "moment";
import { findAllParents } from "../../../utils/common";

const fieldNames = {
  label: "itemName",
  value: "id",
  children: "children",
};
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const StoreManage = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [deviceLs, setDeviceLs] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [selectList, setSelectList] = useState([
    {
      attr: { allowClear: true },
      label: "仓库:",
      name: "storeId",
      message: "请选择仓库",
      options: [],
      span: 8,
      labelCol: 6,
    },
    {
      attr: { allowClear: true },
      label: "供应商:",
      name: "supplierId",
      message: "请选择供应商",
      options: [],
      span: 8,
      labelCol: 6,
    },
  ]);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    stationId,
  });
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "名称:",
      name: "name",
      message: "请输入名称",
      span: 8,
      labelCol: 6,
    },
    {
      label: "型号:",
      name: "partModel",
      message: "请输入型号",
      span: 8,
      labelCol: 6,
    },
    {
      label: "规格:",
      name: "partSpec",
      message: "请输入规格",
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "名称",
      dataIndex: "name",
      align: "center",
      key: "name",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "设备名称",
      dataIndex: "deviceName",
      align: "center",
      key: "deviceName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "仓库名称",
      dataIndex: "storeName",
      align: "center",
      key: "storeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "供应商设备名称",
      dataIndex: "supplierName",
      align: "center",
      key: "supplierName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "库存量",
      dataIndex: "num",
      align: "center",
      key: "num",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "型号",
      dataIndex: "partModel",
      align: "center",
      key: "partModel",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "规格",
      dataIndex: "partSpec",
      align: "center",
      key: "partSpec",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "预警阀值",
      dataIndex: "thresholdNum",
      align: "center",
      key: "thresholdNum",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getDevice();
    getStoreAllByStation();
    supplierAllByStation();
  }, []);

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getDevice = () => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      const ls = getTreeData(res.data);
      setDeviceLs(ls);
    });
  };

  const getTreeData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        id: item.deviceId ? item.deviceId : item.id,
        children: item.child.length ? getTreeData(item.child) : undefined,
        child: undefined,
      };
    });
  };

  const supplierAllByStation = () => {
    SystemApi.supplierAllByStation({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setSupplierList(res.data);
      const index = selectList.findIndex((item) => item.name == "supplierId");
      if (index != -1) {
        selectList[index].options = res.data.map((item) => {
          return {
            title: item.name,
            value: item.id,
          };
        });
        setSelectList([...selectList]);
      }
    });
  };

  const getStoreAllByStation = () => {
    SystemApi.storeAllByStation({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setStoreList(res.data);
      const index = selectList.findIndex((item) => item.name == "storeId");
      if (index != -1) {
        selectList[index].options = res.data.map((item) => {
          return {
            title: item.name,
            value: item.id,
          };
        });
        setSelectList([...selectList]);
      }
    });
  };

  const getListPages = () => {
    setLoading(true);
    SystemApi.storePartList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.storePartRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          if (tableSource.data.length == 1 && tableSource.pageNum > 1) {
            searchParams({
              ...searchParams,
              pageNum: searchParams.pageNum - 1,
            });
          } else {
            getListPages();
          }
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    const {
      storeId,
      num,
      id,
      supplierId,
      thresholdNum,
      name,
      partModel,
      partSpec,
    } = obj;
    setVisible(true);
    setEditId(id);
    const deviceId = findAllParents(
      deviceLs,
      obj.deviceId,
      [],
      "number",
      "children"
    );
    form.setFieldsValue({
      partList: [
        {
          num,
          storeId,
          supplierId,
          thresholdNum,
          name,
          partModel,
          partSpec,
          deviceId,
        },
      ],
    });
  };

  const addRecord = () => {
    setVisible(true);
    form.setFieldsValue({
      partList: [{}],
    });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const partList = values.partList.map((item) => {
        return {
          ...item,
          deviceId: item.deviceId
            ? item.deviceId[item.deviceId.length - 1]
            : undefined,
        };
      });
      if (editId) {
        setConfirmLoading(true);
        SystemApi.storePartUpdate({ ...partList[0], id: editId }).then(
          (res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancel();
            getListPages();
          }
        );
      } else {
        setConfirmLoading(true);
        SystemApi.storePartBatchSave({ partList }).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    setSearchParams({
      ...searchParams,
      ...values,
      pageNum: 1,
      pageSize: 10,
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm
        span={6}
        inputList={inputList}
        selectList={selectList}
        onSearch={search}
      />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={addRecord}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum == 0 ? 1 : tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          width={1200}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.List name="partList">
              {(fields, { add, remove }) => (
                <Row>
                  {fields.map((field) => (
                    <Col
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 10,
                        borderBottom: "1px solid #ddd",
                      }}
                      span={22}
                      key={field.key}
                    >
                      <Row gutter={20}>
                        <Col span={22}>
                          <Row>
                            <Col span={12}>
                              <Form.Item
                                label="名称"
                                name={[field.name, "name"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填写名称!",
                                  },
                                ]}
                              >
                                <Input placeholder={"请填写名称"} />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="型号"
                                name={[field.name, "partModel"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填写型号!",
                                  },
                                ]}
                              >
                                <Input placeholder={"请填写型号"} />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="规格"
                                name={[field.name, "partSpec"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填写规格!",
                                  },
                                ]}
                              >
                                <Input placeholder={"请填写规格"} />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="设备"
                                name={[field.name, "deviceId"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请选择设备!",
                                  },
                                ]}
                              >
                                <Cascader
                                  fieldNames={fieldNames}
                                  options={deviceLs}
                                  placeholder="请选择设备"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="库存量"
                                name={[field.name, "num"]}
                                rules={[
                                  { required: true, message: "请填写库存量!" },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  placeholder={"请填写库存量"}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="预警阀值"
                                name={[field.name, "thresholdNum"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填写预警阀值!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  placeholder={"请填写预警阀值"}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="仓库"
                                name={[field.name, "storeId"]}
                                rules={[
                                  { required: true, message: "请选择仓库!" },
                                ]}
                              >
                                <Select placeholder="请选择仓库">
                                  {storeList.map((item) => (
                                    <Select.Option
                                      value={item.id}
                                      key={item.id}
                                    >
                                      {item.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="供应商"
                                name={[field.name, "supplierId"]}
                                rules={[
                                  { required: true, message: "请选择供应商!" },
                                ]}
                              >
                                <Select placeholder="请选择供应商">
                                  {supplierList.map((item) => (
                                    <Select.Option
                                      value={item.id}
                                      key={item.id}
                                    >
                                      {item.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={2}>
                          {fields.length > 1 && (
                            <Button
                              type="dashed"
                              onClick={() => remove(field.name)}
                            >
                              移除
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  ))}
                  {!editId && (
                    <Col
                      span={2}
                      style={{
                        textAlign: "right",
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <Button type="dashed" onClick={add}>
                        添加
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </Form.List>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(StoreManage);
